import { createSlice } from "@reduxjs/toolkit";
import {
  choosePlanBuilder,
  fetchSubscriptionsBuilder,
  getSubscriptionsCreditsHistoryBuilder,
  rechargeCreditsBuilder,
} from "./builder";
import { LOGOUT } from "../../../utils/constants";

const initialState = {
  subscriptions: [],
  creditsHistory: {
    data: [],
    maxReached: false,
    total: 0,
    perPage: 10,
    page: 1,
    loading: false,
  },
  choosePlanPending: false,
  rechargeCreditsPending: false,
  fetchSubscriptionsPending: false,
};

export const subscriptionSlice = createSlice({
  name: "subscriptionInfo",
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    choosePlanBuilder(builder);
    fetchSubscriptionsBuilder(builder);
    rechargeCreditsBuilder(builder);
    getSubscriptionsCreditsHistoryBuilder(builder);

    builder.addCase(LOGOUT, (state) => ({
      ...initialState,
      subscriptions: state.subscriptions,
      loggedIn: false,
    }));
  },
});

export const { resetState } = subscriptionSlice.actions;

export const selectChoosePlanLoading = (state) =>
  state.subscriptionInfo.choosePlanPending;

export const selectRechargeCreditsLoading = (state) =>
  state.subscriptionInfo.rechargeCreditsPending;

export const selectFetchSubscriptionsLoading = (state) =>
  state.subscriptionInfo.fetchSubscriptionsPending;

export const selectCreditsHistory = (state) =>
  state.subscriptionInfo.creditsHistory;

export const selectSubscriptions = (state) =>
  state.subscriptionInfo.subscriptions;

export default subscriptionSlice.reducer;
